import { FlexGroup, SquareGroup } from './PageSkeleton.styles';

function PageSkeleton(): JSX.Element {
  return (
    <div>
      <FlexGroup>
        <SquareGroup />
        <SquareGroup />
        <SquareGroup />
      </FlexGroup>

      <FlexGroup>
        <SquareGroup />
        <SquareGroup />
        <SquareGroup />
      </FlexGroup>
    </div>
  );
}

export default PageSkeleton;
